import LanguageDropdown from "components/Language/LanguageDropdown"
import React, {Component, Fragment} from "react"
import {Link} from "react-router-dom"
import {Message, Menu, Modal, Button, Label, Form, FormField, FormInput} from "semantic-ui-react"

import {withRouter} from "react-router"
import queryString from "qs"
import "pages/Login.css"
import shop from "shop/shop"
import WordPressContainer from "WordPressContainer"
import config from "config"
import { Table } from "semantic-ui-react";
import Responsive from "react-responsive"
import ContactMessage from "components/Messages/ContactMessage"
import BarcodeScanner from "components/BarcodeScanner/BarcodeScannerJS"

@withRouter
export default class LoginPage extends Component {
	constructor() {
		super()
		this.state = {
			user    : "",
			password: "",
			forgetPassword: false
		}
		shop.whoami()
	}

	handleLogin = ( e ) => {
		const {history} = this.props
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		console.log( {query} )
		const {referrer} = query
		shop.login( {...this.state} )
			.catch( ( err ) => {
				console.error( err )
				shop.toast( translate( "Fehler bei der Anmeldung" ), "error" )
				return false
			} )
			.then( session => {
				if ( !session ) return
				shop.loadCategories()
				shop.cart.hydrate()
				shop.toast( `${translate("Willkommen")} ${session.value.title ? session.value.title : ""}` )
				let redirectTo = referrer || shop.locationAfterLogin
				console.log( "AFTER", redirectTo )
				/*if ( redirectTo ) {
					history.push( redirectTo )
				} else {*/
				if(shop.session.handUser){
					history.push( "/return/admin" )
				}
				else{
					history.push( "/return" )
				}
				//}
			} )

		e.preventDefault()
	}

	handleUserChange = ( event ) => {
		this.setState( {
			user: event.target.value
		} )
	}

	handlePasswordChange = ( event ) => {
		this.setState( {
			password: event.target.value
		} )
	}



	handleModalPassword = () => {
		this.setState(prevState => ({
			forgetPassword: !prevState.forgetPassword
		}));
		console.log("forgetPassword", this.state.forgetPassword);
	};

	render() {
		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		return (
			<Fragment>
				
				
				<Responsive minWidth={790}>
				<div className="LoginPage pb6">
				<div className=" container">
					<div className="black absolute top-0 right-2 pt2">
						<LanguageDropdown />
					</div>
				<section className="container tc pb2 pt2">
				<a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>

					<WordPressContainer postType={"shop"} slug={"login"} />
					<section className="container pb4" style={{width:"35%"}}>
					<Message>
						<ContactMessage />
						</Message>
						
						
						<table className="">
						<colgroup>
							<col width="100%" />
						</colgroup>
						<tbody>
							<tr className="pl7">
								<td>
								<h1 style={{color:"#917236"}} className="tc pt4">Anmeldung</h1>
								</td>
							</tr>
							<tr className="pl4 pr3">
						<td >
							<div className="mw6"
								 style={{marginTop: "10px"}}>
								<Form onSubmit={this.handleLogin}>
									<div >Kundennummer</div>
									<Form.Field 
											   title={translate("Anmeldung mit Kunden-Nr.")}>
										<input value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={translate("Kunden-Nr.")}
												   name="basic-form-input-id" />
									</Form.Field>
									<div>Passwort</div>
									<Form.Field >
										<input value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</Form.Field>
									{/*<Form.Field>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</Form.Field>*/}
									<div className="tr pt3">
										<Button
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<a className="db mt3"
											  onClick={this.handleModalPassword} >{translate( "Passwort vergessen" )}</a>
									</div>
								</Form>
							</div>
						</td>
					</tr>
						</tbody>
							
					</table>
					{this.state.forgetPassword && 
					<Table>
						<tr className="pl4 pr3">
						<td sm="11/12">
						{/*
							<p style={{fontSize:15}} className="pb2 pt4">Sehr geehrter Kunde,</p>
							<p style={{fontSize:15}} className="">Ihr Passwort ist die Postleitzahl Ihres Marktes.</p> */}
							<p style={{fontSize:15}} className="pb4"><b>Restantenhotline: </b>0241 - 8881 7703</p>
						</td>
						</tr>
						
					</Table>}
					</section>
					<hr />

					<div className="center mw6 pb3">
						{/*<Message>
							<div className="b">{translate("LOGIN_NOTICE_HEADER")}</div>

							<div>{translate("LOGIN_NOTICE")}</div>

							<div className={"tc pt3"}>
								<Button as={Link} to={"/request_password"}>{translate("Passwort anfordern")}</Button>
							</div>
						</Message>*/}
					</div>

					{/*<div className="tc pb5">
						<div className="black-50">{translate( "No account yet?" )}</div>
						<Link to="/customer_registration">{translate( "register new account" )}</Link> <br />
						{config.customer_enabling &&
						<Link to="/customer_enabling">{translate( "access with offline account" )}</Link>}
					</div>*/}

					{config.b2cLink && <div>
						<hr />
						<div className="tc">
							<a href={config.b2cLink}>{translate( "B2C Shop" )}</a>
						</div>
					</div>}
				</div>

				<div className="bg-silver fixed bottom-0 left-0 right-0">
				
				<Menu fluid
						secondary
						size="small">
					<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
							position="right">{translate( "Data Policy" )}</Menu.Item>
					<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
				</Menu>
				
				</div>


				<Modal
					open={query.modal && query.slug}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug={query.slug} />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "data"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="datenschutz" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "imprint"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="impressum" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "agb"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="agb" />
					</Modal.Content>
				</Modal>
			</div>
				</Responsive>
				<Responsive maxWidth={789}>
				<section className="container tc pb2 pt2">
				<a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>
					<div className="pa3">
						<Message>
						<ContactMessage />
						</Message>
					
					<table className="">
						<colgroup>
							<col width="100%" />
						</colgroup>
						<tbody>
							<tr className="pl7">
								<td>
								<h1 style={{color:"#917236"}} className="tc pt4">Anmeldung</h1>
								</td>
							</tr>
							<tr className="pl4 pr3">
						<td >
							<div className="mw6"
								 style={{marginTop: "10px"}}>
								<Form onSubmit={this.handleLogin}>
									<div >Kundennummer</div>
									<Form.Field 
											   title={translate("Anmeldung mit Kunden-Nr.")}>
										<input value={this.state.user}
												   onChange={this.handleUserChange}
												   type="text"
												   placeholder={translate("Kunden-Nr.")}
												   name="basic-form-input-id" />
									</Form.Field>
									<div>Passwort</div>
									<Form.Field >
										<input value={this.state.password}
												   onChange={this.handlePasswordChange}
												   type="password"
												   placeholder={translate("Passwort")}
												   name="basic-form-input-password" />
									</Form.Field>
									{/*<Form.Field>*/}
									{/*<Checkbox label="Login speichern" />*/}
									{/*</Form.Field>*/}
									<div className="tr pt3">
										<Button
											primary
											submit
										>{translate( "Anmelden" )}</Button>
										<a className="db mt3"
											  onClick={this.handleModalPassword} >{translate( "Passwort vergessen" )}</a>
									</div>
								</Form>
							</div>
						</td>
					</tr>
						</tbody>
							
					</table>
					</div>
					<div className="bg-silver fixed bottom-0 left-0 right-0">
				
				<Menu fluid
						secondary
						size="small">
					<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "data"} )}}
							position="right">{translate( "Data Policy" )}</Menu.Item>
					<Menu.Item as={Link} to={{pathname: "/login/", search: queryString.stringify( {...query, modal: "imprint"} )}}>{translate( "imprint" )}</Menu.Item>
				</Menu>
				
				</div>


				<Modal
					open={query.modal && query.slug}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug={query.slug} />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "data"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="datenschutz" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "imprint"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="impressum" />
					</Modal.Content>
				</Modal>

				<Modal
					open={query.modal === "agb"}
					closeIcon={<Button floated={"right"} as={Link} to={"/login/"} basic icon={"close"} />}>
					<Modal.Content>
						<WordPressContainer postType="page"
											slug="agb" />
					</Modal.Content>
				</Modal>
					{this.state.forgetPassword && <div className="pa3 ">
					<table className="ba">
						<tr className="pl4 pr3">
						<td sm="11/12">
						{/*
							<p style={{fontSize:15}} className="pb2 pt4">Sehr geehrter Kunde,</p>
							<p style={{fontSize:15}} className="">Ihr Passwort ist die Postleitzahl Ihres Marktes.</p> */}
							<p style={{fontSize:15}} className="pb4"><b>Restantenhotline: </b>0241 - 8881 7703</p>
						</td>
						</tr>
						
					</table>

					</div>}
				</Responsive>
			</Fragment>
		)
	}
}




// WEBPACK FOOTER //
// ./src/theme/lindt/pages/LoginPage.js